import React from "react";
import useSessionTracker from "./utils/useSessionTracker";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { logout } from "./actions/authActions";

export default function SessionTrackerWrapper() {
  const isLoggedIn = useSelector((state) => state.auth.isAuthenticated);
  const dispatch = useDispatch();
  useSessionTracker(isLoggedIn, () => setTimeout(() => dispatch(logout()), 0));
  return null; // Ce composant n'affiche rien
}
